export default "__VITE_ASSET__7022b18f__"